import { DELIVERY_IMAGES } from './constants';

export const getDeliveryImage = (type) => DELIVERY_IMAGES[type] || null;
